import React from 'react';
import { Utils } from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';

export const Image = ({
  src = '',
  object,
  attributeName = 'Image',
  alt,
  ...props
}) => {
  const source =
    typeof object === 'object'
      ? Utils.getAttributeValue(object, attributeName, src)
      : src;
  return (
    <I18n
      render={translate => (
        <img
          src={
            !source || source.startsWith('http')
              ? source
              : `${process.env.PUBLIC_URL}/images${
                  source.startsWith('/') ? '' : '/'
                }${source}`
          }
          alt={translate(alt)}
          {...props}
        />
      )}
    />
  );
};
